/* istanbul ignore file */
import React, { ReactNode } from 'react'
import classnames from 'classnames/bind'
import Text from '../../elementals/text'
import Icon from '../../elementals/icon'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface RadioButtonFieldType {
  centered?: boolean
  displayCheck?: boolean
  label: string | ReactNode
  subLabel?: string
  image?: string
  children?: JSX.Element
  value: string | number
  checked?: boolean
  onChange?: (event: Event | null, data: { type: string; value: any }) => void
  className?: string[]
  disabled?: boolean
  secondary?: boolean
  elmId?: string
}

const RadioButtonField = ({
  centered = true,
  displayCheck = false,
  label,
  subLabel,
  image,
  children,
  value,
  onChange,
  checked,
  disabled,
  className = [],
  secondary = false,
  elmId,
}: RadioButtonFieldType) => {
  const targetImg = typeof image === 'string' ? `url(${image})` : image

  const onClick = () => {
    if (!disabled && onChange) {
      onChange(null, { type: 'radio', value })
    }
  }

  return (
    <div
      className={cx(
        'radio-button-field',
        { selected: checked && !disabled, disabled, secondary },
        ...className
      )}
      onClick={onClick}
      data-elm-id={elmId}
    >
      <div className={cx('radio-button-field-content')}>
        <div
          className={cx('radio-button-field-labels', {
            centered,
            'includes-image': Boolean(image),
          })}
        >
          <div className={cx('radio-button-label-container')}>
            {typeof label === 'string' && (
              <Text size='huge' color='black'>
                {label}
              </Text>
            )}
            {React.isValidElement(label) && label}
            {Boolean(checked && displayCheck) && (
              <Icon color='info' name='check' size='big' iconStyle='regular' />
            )}
          </div>
          {subLabel && (
            <div>
              <Text size='large' color='gray'>
                {subLabel}
              </Text>
            </div>
          )}
          {children && (
            <div className={cx('child-component')}>
              {React.cloneElement(children, { disabled: !checked || disabled })}
            </div>
          )}
        </div>
        {image && (
          <div className={cx('radio-button-image-container')}>
            <div
              style={{ backgroundImage: targetImg }}
              className={cx('radio-button-image')}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default RadioButtonField
